import { Pipe, PipeTransform } from '@angular/core';

import { isHiddenParameter } from '../constants/constants';

@Pipe({ name: 'isHiddenParameter' })
export class IsHiddenParameterPipe implements PipeTransform {
  transform(
    parameter: string,
    userParameters: any,
    resolution: any,
    parameterDefinitions: any
  ) {
    return isHiddenParameter(
      parameter,
      userParameters,
      resolution,
      parameterDefinitions
    );
  }
}
